// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.btn-gray {\n    border-color: lightgray !important;\n}\n.btn-gray:hover {\n    border-color: rgba(0, 0, 0, .87) !important;\n}\n.badge {\n    display: inline-block;\n    background-color: #f2f2f2;\n    padding: 0 5px;\n    border: solid lightgray 1px;\n    border-radius: 5px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
